<template> <v-card elevation="1" class="pa-6 mt-6">
   <div>
      <h4 class="mb-4 d-flex justify-space-between align-center">
        Contact Lists ({{ listCount}})
        <v-btn
          v-if="listCount && !toggleDNEmailSwitch && !toggleDNSmsSwitch && checkProduct"
          icon
          text
          @click="toggleDrawer(contact)"
          v-track="'show-hide-list-drawer'"
        >
          <v-icon>mdi-pencil</v-icon>
        </v-btn>
        <v-btn
          v-if="listCount && (toggleDNEmailSwitch || toggleDNSmsSwitch)"
          text
          @click="getSelectedLists()"
          v-track="'get-selected-list'"
          color="#03B6FC"
        >
          <v-icon v-if="listLoader">mdi-spin mdi-refresh</v-icon>
          <v-icon v-if="!listLoader"> refresh </v-icon>
          <span class="caption" style="text-transform: capitalize"> Refresh</span>
        </v-btn>
      </h4>
      <v-skeleton-loader v-if="listLoader" type="list-item-three-line, action" />
      <div v-else>
        <span class="primary--font subtitle-2 font-weight ">Email Subscription ({{ selectedLists.emailSub.length + selectedLists.emailUnsub.length}})</span>
        <div v-if="selectedLists.emailSub.length + selectedLists.emailUnsub.length">
          <!--  chips for email subscribed lists -->
          <v-chip
            v-for="list in selectedLists.emailSub.slice(0, showAllTags ? selectedLists.emailSub.length : 3)"
            :key="list.id"
            class="my-1 mr-4 "
            color="#cce1ef"
          >
            {{ list.name }}
          </v-chip>
          <!--  chips for email Unsubscribed lists -->
          <v-chip
            v-for="list in selectedLists.emailUnsub.slice(0, showAllTags ? selectedLists.emailUnsub.length : 3)"
            :key="list.id"
            class="my-1 mr-4 "
            color="#EFC5CA"
          >
            {{ list.name }}
          </v-chip>

          <v-btn
            v-if="selectedLists.emailUnsub.length + selectedLists.emailSub.length  > 3"
            text
            @click="showAllTags = !showAllTags"
            v-track="'show-hide-all-tags'"
          >
            VIEW {{ showAllTags ? "LESS" : "ALL" }}
          </v-btn>
        </div>
        <v-divider class="my-3"/>
        <div>
          <span class="primary--font subtitle-2 font-weight">SMS Subscription({{ selectedLists.smsSub.length + selectedLists.smsUnsub.length}})</span>
           <!--  chips for sms subscribed lists -->
          <div v-if="selectedLists.smsSub.length + selectedLists.smsUnsub.length">
            <v-chip
              v-for="list in selectedLists.smsSub.slice(0, showAllTags ? selectedLists.smsSub.length : 1)"
              :key="list.id"
              class="my-1 mr-4 mt-4"
              color="#cce1ef"
            >
              {{ list.name }}
            </v-chip>
             <!-- chips for sms Unsubscribed lists -->
            <v-chip
              v-for="list in selectedLists.smsUnsub.slice(0, showAllTags ? selectedLists.smsUnsub.length : 1)"
              :key="list.id"
              class="my-1 mr-4 mt-4"
              color="#EFC5CA"
            >
              {{ list.name }}
            </v-chip>
            <v-btn
              v-if="selectedLists.smsUnsub.length + selectedLists.smsSub.length  > 3"
              text
              @click="showAllTags = !showAllTags"
              v-track="'show-hide-all-tags'"
            >
              VIEW {{ showAllTags ? "LESS" : "ALL" }}
            </v-btn>
          </div>
        </div>
        <div
          v-if="!listCount"
          style="min-height: 81.9px"
          class=" mt-3 d-flex flex-column"
        >
          <v-label> No Lists to show.</v-label>
          <v-label>Add the customer to lists to send emails.</v-label>
          <div class="mt-6">
            <v-tooltip bottom right :disabled="!toggleDNEmailSwitch && !toggleDNSmsSwitch">
              <template v-slot:activator="{ on }">
                <v-btn
                  v-if="checkProduct"
                  outlined
                  :style="(toggleDNEmailSwitch && toggleDNSmsSwitch) ? 'cursor:not-allowed' : 'cursor:pointer'"
                  :ripple="(!toggleDNEmailSwitch && !toggleDNSmsSwitch) "
                  @click.stop="(!toggleDNEmailSwitch && !toggleDNSmsSwitch) ? toggleDrawer() : ''"
                  v-on="on"
                  v-track="'show-hide-DNM-switch'"
                >
                  ADD TO LISTS
                </v-btn>
              </template>
              <span
                >To add the customer to lists<br />
                turn off the DNM switch first</span
              >
            </v-tooltip>
          </div>
        </div>
      </div>
      <v-divider v-if="checkProduct" class="mt-7" />
      <div v-if="checkProduct" class="d-flex justify-space-between align-center mb-n6">
        <label> Add to Do Not Email List</label>
        <v-switch
          v-track="'add-remove-dnm-switch'"
          v-model="toggleDNEmailSwitch"
          color="#03B6FC"
          @click.stop.prevent="showPrompt = true"
        />
      </div>
      <div v-if="showReason">
        <v-row>
          <v-col cols="1" class="pb-0">
            <v-icon>mdi-menu-right</v-icon>
          </v-col>
          <v-col class="pb-0">
            <span v-if="dnmReason === null" class="body-2 dnm-text">
              Contact added to DNM <b>- Reason : Not Available</b>
            </span>
            <span class="body-2 dnm-text" v-else>
              Contact added to DNM via <b>{{ dnmReason }}</b>
            </span>
          </v-col>
        </v-row>
        <div class="ml-10" v-if="showDescription">
          <v-row no-gutters>
            <v-col cols="1">
              <v-icon>mdi-subdirectory-arrow-right</v-icon>
            </v-col>
            <v-col class="mt-1">
              <span class="body-2 dnm-text">
                Through <b>'{{ dnmReasonDescription }}'</b>
              </span>
            </v-col>
          </v-row>
        </div>
      </div>
      <div v-if="checkProduct" class="d-flex justify-space-between align-center mb-n6">
            <label > Add to Do Not SMS List</label>
            <v-switch
                v-model="toggleDNSmsSwitch"
                color="#03B6FC"
                @click.stop.prevent="showSmsPrompt = true"
            />
          </div>
            <div v-if="showSmsReason">
                      <v-row>
                        <v-col cols="1" class="pb-0">
                          <v-icon>mdi-menu-right</v-icon>
                        </v-col>
                        <v-col class="pb-0">
                          <span class="body-2 dnm-text">
                            Contact added to DNM via <b>{{ dnmSmsReason }}</b>
                          </span>
                        </v-col>
                      </v-row>
                    </div>
            <v-dialog 
                v-model="showSmsPrompt" 
                max-width="500"
            >
                <v-card class="standard-modal">
                    <v-card-title class="secondary--font">
                        {{ toggleDNSmsSwitch ? "Remove from" : "Add to" }} Do Not SMS List?
                    </v-card-title>

                    <v-card-subtitle v-if="toggleDNSmsSwitch" class="subtitle-1 only-top-padding">
                        The contact will be removed from Do Not SMS List and can be again subscribed in SMS Contact Lists.
                    </v-card-subtitle>
                    <v-card-subtitle v-else class="subtitle-1 only-top-padding">
                        The customer will automatically be unsubscribed from all the 
                        lists and no SMS will be sent once added to the Do Not SMS List.
                    </v-card-subtitle>
                    <v-card-actions>
                        <v-spacer />

                        <v-btn text @click="showSmsPrompt=false" class="body-2 font-weight-bold"> CANCEL </v-btn>

                        <v-btn text @click.stop="updateDNM" class="body-2 font-weight-bold">
                        {{ toggleDNSmsSwitch ? "REMOVE" : "ADD" }}
                        </v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>
      <v-dialog v-model="showPrompt" max-width="500">
        <v-card class="standard-modal">
          <v-card-title class="secondary--font">
            <h4>{{ toggleDNEmailSwitch ? "Remove from" : "Add to" }} Do Not EMail List?</h4>
          </v-card-title>

          <v-card-subtitle v-if="toggleDNEmailSwitch" class="subtitle-1 only-top-padding">
            The customer will be subscribed to the lists they are added to and will
            receive all marketing emails once removed from the Do Not Mail List.
          </v-card-subtitle>
          <v-card-subtitle v-else class="subtitle-1 only-top-padding">
            The customer will automatically be unsubscribed from all the lists and No
            marketing emails will be sent once added to the Do Not Mail List.
          </v-card-subtitle>
          <v-card-actions>
            <v-spacer />

            <v-btn
              v-track="'cancel-dnm-btn'"
              text
              class="body-2 font-weight-bold"
              @click="showPrompt = false"
            >
              CANCEL
            </v-btn>

            <v-btn
              v-track="'add-remove-dnm-btn'"
              text
              :loading="listLoader"
              class="body-2 font-weight-bold"
              @click.stop="addToDNM"
            >
              {{ toggleDNEmailSwitch ? "REMOVE" : "ADD" }}
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-divider class="my-6"/>
      <div class="d-flex">
        <v-icon small
        color="#cce1ef" class="pr-3"> mdi-checkbox-blank-circle</v-icon>
        <span class=" mr-7">Subscribed</span>
        <v-icon small
        color="#EFC5CA" class="pr-3"> mdi-checkbox-blank-circle</v-icon>
        <span>Unsubscribed</span>
      </div>
      <div>
        
      </div>

    </div>
  </v-card>
</template>
<script>
import { $marketingContacts } from "@core/services";
export default {
  props: {
    contactId: [Number, String],
    contact: {
      type: Object,
    },
  },
  data() {
    return {
      selectedLists: {
        emailSub:[],
        emailUnsub:[],
        smsSub:[],
        smsUnsub:[]
      },
      listLoader: false,
      showAllTags: false,
      drawer: false,
      toggleDNEmailSwitch: false,
      toggleDNSmsSwitch: false,
      showReason: false,
      showDescription: false,
      dnmReason: "",
      dnmReasonDescription: "",
      showPrompt: false,
      showSmsPrompt: false,
      pseudonymized:false,
      dnmSmsReason: '',
      showSmsReason: false,
      loading: true,
    };
  },
  watch: {
    "$store.state.ui.drawer.right.response": function () {
      if (this.$store.getters["ui/drawer"].right.response.contactList) {
        let lists = this.$store.getters["ui/drawer"].right.response.contactList;
        this.selectedLists.emailSub = lists.subscribed_lists.email;
        this.selectedLists.emailUnsub = lists.unsubscribed_lists.email;        ;
        this.selectedLists.smsSub = lists.subscribed_lists.sms;
        this.selectedLists.smsUnsub = lists.unsubscribed_lists.sms;
      }
    },
    contact(value) {
      if (value) this.getSelectedLists();
    },
  },
  computed: {
    checkProduct() {
      return process.env.VUE_APP_PRODUCT != "Service";
    },
    listCount(){
      // Get the unique count of lists, as the same list can be used in both SMS and Email subscriptions.
      let all_lists  = this.selectedLists.emailSub.concat(this.selectedLists.emailUnsub, this.selectedLists.smsSub, this.selectedLists.smsUnsub);
      const listsSet = new Set(all_lists.map(item => item.id))
      return listsSet.size
    }
  },
  mounted() {
    this.getDNMStatus();
  },
  methods: {
    getSelectedLists() {
      this.listLoader = true;
      const payload = {
        params: {
          "contact[email]": this.contact.email,
        },
      };
      $marketingContacts.getSubscribedLists(this.contactId, payload).then((response) => {
        this.selectedLists.emailSub = response.data.data.subscribed_lists.email;
        this.selectedLists.emailUnsub = response.data.data.unsubscribed_lists.email;        ;
        this.selectedLists.smsSub = response.data.data.subscribed_lists.sms;
        this.selectedLists.smsUnsub = response.data.data.unsubscribed_lists.sms;
        this.listLoader = false;
      });
    },
    toggleDrawer(item) {
      this.$store.state.ui.drawer.right.component = "lists-drawer";
      this.$store.state.ui.drawer.right.contact = item
      // this.contactList = JSON.parse(JSON.stringify(this.contactList))
      this.$store.state.ui.drawer.right.show = true;
      this.drawer = !this.drawer;
    },
    getDNMStatus() {
      this.showReason  = false;
      this.showSmsReason = false;
      this.showDescription = false;
      this.pseudonymized = false;
      $marketingContacts.dnmStatus(this.contactId).then((response) => {
        this.toggleDNEmailSwitch = response.data.email.in_dnm;
        this.toggleDNSmsSwitch = response.data.sms.in_dnm;
        this.dnmReason = response.data.email.reason_type;
        this.dnmReasonDescription = response.data.email.reason_description;
        this.dnmSmsReason = response.data.sms.reason_type;
        this.pseudonymized = response.data.is_pseudonymized;
        if(this.toggleDNEmailSwitch) {
          this.showReason = true;
        }
        if(this.dnmReasonDescription) {
          this.showDescription = true;
        }
        if(this.toggleDNSmsSwitch) {
           this.showSmsReason = true
        }
        if(this.pseudonymized){
          this.showSmsReason = true
        }
      });
    },
    addToDNM() {
      this.listLoader = true;
      $marketingContacts
        .updateDNMStatus(this.toggleDNEmailSwitch, {
          contact_id: this.contactId,
        })
        .then((response) => {
          this.listLoader = false;
          this.getSelectedLists();
          this.getDNMStatus();
          this.showPrompt = false;
         
          this.toggleDNEmailSwitch = !this.toggleDNEmailSwitch;
        });
    },
    updateDNM () {
            this.loading = true
            $marketingContacts.updateDNMSms(this.toggleDNSmsSwitch, this.contactId).then(response => {
                this.getSelectedLists()
                this.getDNMStatus()
                this.showSmsPrompt =  false;
                this.loading = false
                this.toggleDNSmsSwitch = !this.toggleDNSmsSwitch
                }).catch(error => {
                this.loading = false
            })
        },
  },
};
</script>

<style lang="scss" scoped>
.dnm-text {
  color: rgba(0, 0, 0, 0.6);
  .font-weight{
    font-weight:500 
  }
}
</style>
